import { Component } from '@angular/core';

@Component({
  selector: 'tun-shuffle-icon-v5',
  templateUrl: './shuffle-icon-v5.component.html',
  styleUrls: ['./shuffle-icon-v5.component.scss']
})
export class ShuffleIconV5Component {

}
